<template>
	<div>
		<!-- Duplicate Product -->
		<modal v-if="(showVideoModal === false)" class="product-dropship-modal" size="large" @close="$emit('close')">
			<!-- <div slot="header">
				<h3><i class="material-icons">add</i>{{ $t('dropship.sell') }}</h3>
			</div> -->
			<div slot="body">
				<!-- {{ product }} -->

				<div class="container-fliud">
					<div class="wrapper row">
						<div class="col-md-6">
							<div class="px-4">
								<VueSlickCarousel
								ref="carouselmain"
								v-bind="carouselMain"
								@beforeChange="onBeforeChangeMain"
								>
									<div v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-main" />
									</div>
									<div v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-main" />
									</div>
								</VueSlickCarousel>
							</div>
							<div class="px-4">
								<VueSlickCarousel
								ref="carouselthumb"
								v-bind="carouselControl"
								@beforeChange="onBeforeChangeThumb"
								>
									<div v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-thumb" />
									</div>
									<div v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-thumb" @click="showVideo(true)" />
									</div>
								</VueSlickCarousel>
							</div>
							<!-- <div class="preview-pic tab-content">
								<div v-for="(picture, index) in product.pictures" :key="index" class="tab-pane" :class="{'active': index === 0}" :id="'pic-' + index">
									<img :src="picture" />
								</div> -->
								<!-- <div v-if="(video_url !== '')" :id="'pic-' + getIndexOfVideo" class="tab-pane">
									<img :src="video_url" />
								</div> -->
							<!-- </div>
							<ul class="preview-thumbnail nav nav-tabs">
								<li v-for="(picture, index) in product.pictures" :key="index" :class="{'active': index === 0}">
									<a :data-target="'#pic-'+index" data-toggle="tab"
										><img :src="picture"
									/></a>
								</li> -->
								<!-- <li v-if="(video_url !== '')" :key="getIndexOfVideo" class="">
									<a :data-target="'#pic-'+getIndexOfVideo" data-toggle="tab"
										><img :src="video_url"
									/></a>
								</li> -->
							<!-- </ul> -->
						</div>
						<div class="details col-md-6">
							<h3 class="product-title">{{ product.name }}</h3>
							<!-- <p class="product-description">
								Suspendisse quos? Tempus cras iure temporibus? Eu laudantium
								cubilia sem sem! Repudiandae et! Massa senectus enim minim
								sociosqu delectus posuere.
							</p> -->
							<h4 class="price">Harga Rekomendasi: <span>{{price}} </span></h4>
							<div class="subtitle">Harga modal : <span>{{ formatMoney(product.price) }}</span></div>
							<div v-if="product.stock.enabled" class="stock">Stock : <span>{{ getStockQuantity(product) }}</span></div>
							<strong>Preview Landing Page: </strong>
							<p class="vote">
								<ul>
									<li v-for="(page, index) in product.pages" :key="index">
										<div class="dropship-product-detail">
											<a target="_blank" :href="page.url" class="dropship-product-detail mr-2"><strong>{{ page.type.label }}</strong> </a>
											<a target="_blank" :href="page.url" class="btn btn-primary btn-detail">
												<div v-if="page.type.value === 'orderonline'">
													<i class="material-icons">content_copy</i>
													Duplicate
												</div>
												<div v-else>
													<i class="material-icons">download</i>
													Download
												</div>
											</a>
										</div>

										<ul>
											<li v-for="(preview, i) in page.previews" :key="i">
												<a target="_blank" :href="preview.url" class="dropship-product-preview">
													<span class="link-preview d-flex align-items-center">
														{{ preview.title }} <i class="ml-1 material-icons link-preview">launch</i>
													</span>
												</a>
											</li>
										</ul>
									</li>
								</ul>
							</p>
							<!-- Description -->
							<div class="description">
								<p v-html="this.sanitizeHtml(product.description)"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="$emit('close')">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>

		<modal v-if="(showVideoModal === true)" class="product-dropship-modal" size="large" @close="$emit('close')">
			<div slot="body">
				<div class="container-fliud">
					<div class="wrapper row">
						<div class="col-md-12">
							<h4 class="product-title">{{ product.name }}</h4>
						</div>
						<div class="col-md-12">
							<div class="embed-responsive embed-responsive-16by9">
								<iframe class="embed-responsive-item" :src="videoEmbedUrl(videos[0])" allowfullscreen></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="showVideo(false)">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>
	</div>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import {
	formatMoney, getYoutubeThumb, getYoutubeId, sanitizeHtml,
} from '@/lib/helper';
import Modal from '@/components/Modal.vue';

export default {
	name: 'ProductDropshipDetail',
	props: {
		product: {
			type: Object,
			default() {},
		},
		price: {
			type: String,
			default: '0',
		},
		max: {},
		format: {
			type: String,
			default: 'int', // int, float
		},
	},
	components: {
		Modal, VueSlickCarousel,
	},
	data() {
		return {
			isLoading: false,
			carouselMain: {
				arrows: false,
				asNavFor: this.$refs.carouselthumb,
				focusOnSelect: true,
			},
			carouselControl: {
				arrows: true,
				asNavFor: this.$refs.carouselmain,
				slidesToShow: 5,
				focusOnSelect: true,
			},
			videos: this.product.videos || [''],
			showVideoModal: false,
		};
	},
	methods: {
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const quantity = isSimple ? product.stock.quantity : product.variations.prices.reduce((prevQty, variation) => {
				const variationQuantity = variation.stock ? variation.stock.quantity : 0;
				const totalQuantity = prevQty + variationQuantity;
				return totalQuantity;
			}, 0);
			return quantity;
		},
		youtubeThumb(url) {
			console.log(url);
			const vidUrl = url || '';
			return getYoutubeThumb(vidUrl);
		},
		showVideo(state) {
			this.showVideoModal = state;
		},
		videoEmbedUrl(videoUrl) {
			const videoId = getYoutubeId(videoUrl);
			return `https://www.youtube.com/embed/${videoId}`;
		},
		formatMoney(price) {
			return formatMoney(price);
		},
		onBeforeChangeThumb(currentPosition, nextPosition) {
			this.$refs.carouselmain.goTo(nextPosition);
		},
		onBeforeChangeMain(currentPosition, nextPosition) {
			this.$refs.carouselthumb.goTo(nextPosition);
		},
		sanitizeHtml,
	},
	computed: {
		isShowAddProduct() {
			return this.show;
		},
		getIndexOfVideo() {
			return this.product.pictures.length + 1;
		},
	},
};
</script>
<style scoped>
/*****************globals*************/

::v-deep .slick-arrow:before {
	color: #2f3241;
	opacity: 1;
}

/* button.slick-arrow.slick-prev {
  left: -20px;
}

button.slick-arrow.slick-next {
  right: -20px;
} */

.dropship-product-preview {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 1px;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* img {
	max-width: 100%;
} */

img.img-thumb {
	padding: 3px;
	border-radius: 10px;
	max-height: 76px;
}

img.img-main {
	border-radius: 10px;
	max-height: 380px;
}

.preview {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}
@media screen and (max-width: 996px) {
	.preview {
		margin-bottom: 20px;
	}
}

.preview-pic {
	-webkit-box-flex: 1;
	-webkit-flex-grow: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
	max-height: 350px;
}

.preview-thumbnail.nav-tabs {
	border: none;
	margin-top: 15px;
}
.preview-thumbnail.nav-tabs li {
	width: 18%;
	margin-right: 2.5%;
}
.preview-thumbnail.nav-tabs li img {
	max-width: 100%;
	display: block;
	border-radius: 4px;
}
.preview-thumbnail.nav-tabs li a {
	padding: 0;
	margin: 0;
}
.preview-thumbnail.nav-tabs li:last-of-type {
	margin-right: 0;
}

.tab-content {
	overflow: hidden;
}
.tab-content img {
	width: 100%;
	border-radius: 4px;
	-webkit-animation-name: opacity;
	animation-name: opacity;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
}

.card {
	margin-top: 50px;
	background: #eee;
	padding: 3em;
	line-height: 1.5em;
}

@media screen and (min-width: 997px) {
	.wrapper {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
	}
}

.details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.colors {
	-webkit-box-flex: 1;
	-webkit-flex-grow: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
}

.product-title,
.price,
.sizes,
.colors {
	/* text-transform: UPPERCASE; */
	font-weight: bold;
}

.checked,
.price span {
	color: #ff9f1a;
}

.product-title,
.product-description {
	margin-bottom: 15px;
}

.price {
	margin-bottom: 2px;
}

.subtitle {
	margin-bottom: 2px;
	font-weight: bolder;
}

.stock {
	margin-bottom: 2px;
	margin-bottom: 4px;
	color: red;
	font-size: 0.9rem;
	/* font-size: bolder; */
}

.subtitle span {
	font-weight: bolder;
}

.product-title {
	margin-top: 0;
}

.size {
	margin-right: 10px;
}
.size:first-of-type {
	margin-left: 40px;
}

.color {
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	height: 2em;
	width: 2em;
	border-radius: 2px;
}
.color:first-of-type {
	margin-left: 20px;
}

.not-available {
	text-align: center;
	line-height: 2em;
}
.not-available:before {
	/* font-family: fontawesome; */
	content: '\f00d';
	color: #fff;
}

.tooltip-inner {
	padding: 1.3em;
}

ul {
	list-style-type: none;
    padding-inline-start: 0px;
}
li ul {
    padding-inline-start: 20px;
}

@-webkit-keyframes opacity {
	0% {
		opacity: 0;
		-webkit-transform: scale(3);
		transform: scale(3);
	}
	100% {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
	}
}

@keyframes opacity {
	0% {
		opacity: 0;
		-webkit-transform: scale(3);
		transform: scale(3);
	}
	100% {
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
	}
}

/*# sourceMappingURL=style.css.map */
</style>
